
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/user-info-card.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-user-info-card-demo-async-data","docs-power-design-user-info-card-demo-long-fields","docs-power-design-user-info-card-demo-status","docs-power-design-user-info-card-demo-popover","docs-power-design-user-info-card-demo-empty"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/user-info-card.md?type=demo')
};